import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/image/index_ligth.png'
import _imports_1 from '../assets/image/leaf1.png'
import _imports_2 from '../assets/image/leaf2.png'
import _imports_3 from '../assets/image/leaf3.png'
import _imports_4 from '../assets/image/leaf4.png'
import _imports_5 from '../assets/image/leaf5.png'
import _imports_6 from '../assets/image/leaf6.png'
import _imports_7 from '../assets/image/leaf7.png'
import _imports_8 from '../assets/image/leaf8.png'
import _imports_9 from '../assets/image/i_t_1.png'
import _imports_10 from '../assets/image/i_t_2.png'
import _imports_11 from '../assets/image/index_tree_2.png'
import _imports_12 from '../assets/image/index_y1.png'
import _imports_13 from '../assets/image/index_y2.png'
import _imports_14 from '../assets/image/index_tree_y2.png'
import _imports_15 from '../assets/image/index_tree_light.png'
import _imports_16 from '../assets/image/logo.png'
import _imports_17 from '../assets/image/index_title.png'
import _imports_18 from '../assets/image/index_star.png'
import _imports_19 from '../assets/image/index_hu.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-2cb422fb")

_pushScopeId("data-v-2cb422fb")
const _hoisted_1 = { class: "index" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "ligth",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"6.6vw","top":"1vh","right":"-5vw","animation":"i-leaf 8s 0s linear infinite"},
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"6.6vw","top":"20vh","right":"-5vw","animation":"i-leaf 6s 0s linear infinite"},
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"6.6vw","top":"15vh","right":"-5vw","animation":"i-leaf 10s 0s linear infinite"},
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"4.6vw","top":"7vh","right":"-5vw","animation":"i-leaf 7s 2s linear infinite"},
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"3.6vw","top":"9vh","right":"-5vw","animation":"i-leaf 5s 1s linear infinite"},
  src: _imports_5,
  alt: ""
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"3.6vw","top":"18vh","right":"-5vw","animation":"i-leaf 12s 0s linear infinite"},
  src: _imports_6,
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"3.6vw","top":"5vh","right":"-5vw","animation":"i-leaf 9s 0s linear infinite"},
  src: _imports_7,
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "leaf",
  style: {"width":"4.6vw","top":"13vh","right":"-5vw","animation":"i-leaf 11s 1s linear infinite"},
  src: _imports_8,
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "tree1",
  src: _imports_9,
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "tree2",
  src: _imports_10,
  alt: ""
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "tree-foot",
  src: _imports_11,
  alt: ""
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "ying1",
  src: _imports_12,
  alt: ""
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "ying2",
  src: _imports_13,
  alt: ""
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "ying3",
  src: _imports_14,
  alt: ""
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  class: "ying4",
  src: _imports_15,
  alt: ""
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_16,
  alt: "logo"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("img", {
  class: "title",
  src: _imports_17,
  alt: "雨林行"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  class: "fly",
  src: _imports_19,
  alt: "蝴蝶"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _hoisted_10,
    _hoisted_11,
    _hoisted_12,
    _hoisted_13,
    _hoisted_14,
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _hoisted_19,
    _createVNode("img", {
      class: "star",
      src: _imports_18,
      alt: "开启旅程",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStart && _ctx.handleStart(...args)))
    }),
    _hoisted_20
  ]))
})